import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { completeSilentRenew } from '@/auth/auth-service';

/**
 * Cible de l'iframe cachée du renouvellement silencieux (`silent_redirect_uri`).
 * oidc-client-ts poste le résultat à la fenêtre parente : il n'y a rien à afficher, et surtout
 * rien à monter (ni thème, ni i18n, ni requête) — cette page vit dans une iframe de 0 pixel.
 */
export const Route = createFileRoute('/silent-callback')({ component: SilentCallbackRoute });

function SilentCallbackRoute() {
  const [done, setDone] = useState<'pending' | 'ok' | 'failed'>('pending');

  useEffect(() => {
    let cancelled = false;
    void completeSilentRenew().then(
      () => !cancelled && setDone('ok'),
      () => !cancelled && setDone('failed'),
    );
    return () => {
      cancelled = true;
    };
  }, []);

  // Aucun texte : rien ici n'est destiné à être lu par un humain (donc rien à traduire).
  return <div hidden data-silent-renew={done} />;
}
